module.exports = __webpack_public_path__ + "img/974.bb400370.png";